import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface TestimonialsProps {
  title: string
  titleEn?: string
  items: Array<{
    name: string
    nameEn?: string
    role: string
    roleEn?: string
    content: string
    contentEn?: string
    avatarUrl?: string
  }>
}

export default function TestimonialsBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as TestimonialsProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.items && p.items.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {(p.items || []).map((item, i) => (
            <div key={i} className="p-6 rounded-2xl bg-white border border-black/[0.04]">
              <p className="text-xs text-gray-500 leading-relaxed mb-4">
                "{lang === 'en' && item.contentEn ? item.contentEn : item.content}"
              </p>
              <div className="flex items-center gap-3">
                {item.avatarUrl ? (
                  <img src={item.avatarUrl} alt="" className="h-9 w-9 rounded-full object-cover" />
                ) : (
                  <div className="h-9 w-9 rounded-full flex items-center justify-center text-white text-xs font-medium"
                    style={{ backgroundColor: branding.primaryColor }}>
                    {(lang === 'en' && item.nameEn ? item.nameEn : item.name)?.[0] || 'U'}
                  </div>
                )}
                <div>
                  <p className="text-xs font-medium" style={{ color: branding.secondaryColor }}>
                    {lang === 'en' && item.nameEn ? item.nameEn : item.name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {lang === 'en' && item.roleEn ? item.roleEn : item.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
